var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var _a;
import React, { useEffect, useState } from "react";
import "@frameworks/shared-library/stylesheets/components/GenericTimeline/GenericTimeline.scss";
import Edelicon from "@frameworks/shared-library/components/Generic/Edelicon";
export var ETimelineState;
(function (ETimelineState) {
    ETimelineState["COMPLETED"] = "completed";
    ETimelineState["IN_PROGRESS"] = "inProgress";
    ETimelineState["FAILED"] = "failed";
    ETimelineState["UNREACHED"] = "unreached";
})(ETimelineState || (ETimelineState = {}));
var TimelineStatusIcon = (_a = {},
    _a[ETimelineState.COMPLETED] = { icon: "edel-icon-success" },
    _a[ETimelineState.IN_PROGRESS] = { icon: "edel-icon-hollow-circle", path: 2 },
    _a[ETimelineState.FAILED] = { icon: "edel-icon-error-thin", path: 2 },
    _a[ETimelineState.UNREACHED] = { icon: "edel-icon-round-circle" },
    _a);
/**
 * GenericTimeline
 *
 * This component can be used to provide visual representation of any setp by step flows
 * Example: Order timeline, Payment timeline
 *
 * @param {Array<ITimelineEvent>} timelineDetails - Timeline steps(events) details
 * @param {string} parentClassName - Any parent scss class to control stylings
 * @returns {}
 */
var GenericTimeline = function (props) {
    var _a;
    var _b = __read(useState(props.timelineDetails), 2), timelineEvents = _b[0], setTimelineEvents = _b[1];
    // This useEffect is to re-render the component when timeline details gets updated
    useEffect(function () {
        if (props.timelineDetails) {
            setTimelineEvents(props.timelineDetails);
        }
    }, [props.timelineDetails]);
    return (React.createElement("ul", { className: "timeline-main ".concat((_a = props === null || props === void 0 ? void 0 : props.parentClassName) !== null && _a !== void 0 ? _a : "", " ") }, timelineEvents.map(function (item, index) {
        var _a, _b;
        return (React.createElement("li", { className: "d-flex flex-row align-items-lg-start gap-2 mb-20", key: index },
            React.createElement("div", { className: "timeline-path flexCenter" },
                React.createElement("div", { className: "flexCenter" }, item.customIcon ? (item.customIcon) : (React.createElement(Edelicon, { className: (_a = TimelineStatusIcon[item.status]) === null || _a === void 0 ? void 0 : _a.icon, paths: (_b = TimelineStatusIcon[item.status]) === null || _b === void 0 ? void 0 : _b.path }))),
                React.createElement("span", { className: "connector-line\n                  ".concat(item.status && item.status === ETimelineState.COMPLETED
                        ? "connector-solid-line"
                        : "connector-dotted-line", "\n                ") })),
            React.createElement("div", { className: "d-flex flex-column status-details" },
                React.createElement("label", { className: "DMSansMedium_12_500 status-text" }, item.header),
                React.createElement("label", { className: "Roboto_12_400 status-description" }, item.description || "_"))));
    })));
};
export default GenericTimeline;
